import React from "react"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import * as Constants from "../../common/constants"
import * as ErrorMessage from "../../common/errorMessage"
import * as Regex from "../../common/regex"
import * as Alert from "../../services/sweetalertService"
import * as API from "../../services/httpService"
import { navigate } from "gatsby"
import { Row, Col } from "react-bootstrap"
import FormTextbox from "../shared/formTextbox"
import FormFieldDisableAutoComplete from "../shared/formFieldDisableAutoComplete"
import FormRadioButton from "../shared/formRadioButton"
import FormMobileTextBox from "../shared/formMobileTextBox"
import {
  pageIncrement,
  updateClickedNext,
  updateValidFormData,
  controlLoading,
  updateUiData,
  updateFromGetData,
} from "../../redux/actions"
import { useDispatch, batch } from "react-redux"

const PolicyInformation = ({ claimData, uiData }) => {
  // console.log("PolicyInformation rendered!")
  const {
    pageNumber,
    clickedNext,
    draftFolderPrefix,
    hideHeaderFooter,
  } = uiData

  const dispatch = useDispatch()
  const policyFormRef = React.useRef()

  const policyInfoSchema = Yup.object().shape({
    policyNumber: Yup.string()
      .length(8, ErrorMessage.policyNumber)
      .required(ErrorMessage.policyNumber)
      .matches(Regex.policyPattern, ErrorMessage.policyNumber),

    policyHolderName: Yup.string()
      .required(ErrorMessage.policyHolderName)
      .matches(Regex.namepattern, ErrorMessage.policyHolderName),

    claimantName: Yup.string()
      .required(ErrorMessage.claimantName)
      .matches(Regex.namepattern, ErrorMessage.claimantName),

    claimantNricNumber: Yup.string()
      .required(ErrorMessage.claimantNricNumber)
      .length(9, ErrorMessage.claimantNricNumber)
      .matches(Regex.nricpattern, ErrorMessage.claimantNricNumber),

    claimantEmail: Yup.string()
      .required(ErrorMessage.claimantEmail)
      .email(ErrorMessage.claimantEmail),

    claimantMobile: Yup.string()
      .required(ErrorMessage.claimantMobile)
      .matches(Regex.mobilepattern, ErrorMessage.claimantMobile),
  })

  return (
    <Formik
      initialValues={Object.assign({}, claimData["claimPADetail"])}
      enableReinitialize={true}
      validationSchema={policyInfoSchema}
      validateOnMount={true}
      innerRef={policyFormRef}
      onSubmit={(values, actions) => {}}
    >
      {({ handleSubmit, isValid, values, errors }) => (
        <FormikForm onSubmit={handleSubmit}>
          <Row
            className={
              pageNumber === Constants.policyInfoPageNumber ? "" : "hide"
            }
          >
            <div
              className={
                "title text-center" +
                " " +
                (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
              }
            >
              Submit online Personal Accident claim
            </div>
            <Row className={"containerBody marginTop3x"}>
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="horizontal-align marginBottom1x">
                  <Col xs={12} md={12}>
                    <div
                      className={
                        "titleText " +
                        (pageNumber !== Constants.policyInfoPageNumber
                          ? "hide"
                          : "")
                      }
                    >
                      Policy Information
                    </div>
                  </Col>
                </div>
                <div>
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc={"Policy Number"}
                    maxLength={8}
                    name="policyNumber"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc={"Policyholder’s name as per NRIC"}
                    maxLength={100}
                    name="policyHolderName"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc={"Is the claimant the policy holder?"}
                    name="isClaimantPolicyholder"
                    component={FormRadioButton}
                  />
                  {!values.isClaimantPolicyholder && (
                    <>
                      {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                      <Field
                        textDesc={"Disable Auto Complete"}
                        name="disableAutoComplete2"
                        component={FormFieldDisableAutoComplete}
                      />
                      <Field
                        textDesc={"Claimant Name as per NRIC"}
                        maxLength={100}
                        name="claimantName"
                        component={FormTextbox}
                        toUpperCase={true}
                      />
                    </>
                  )}
                  <Field
                    textDesc={"Claimant NRIC/FIN Number"}
                    maxLength={9}
                    name="claimantNricNumber"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc={"Email ID"}
                    maxLength={100}
                    name="claimantEmail"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc={"Mobile number"}
                    maxLength={8}
                    name="claimantMobile"
                    component={FormMobileTextBox}
                  />
                </div>
              </Col>
            </Row>
          </Row>
          <HandleFormValidation
            currentPageClickedNext={clickedNext[Constants.policyInfoPageNumber]}
            policyFormRef={policyFormRef}
            values={values}
            pageNumber={Constants.policyInfoPageNumber}
            dispatch={dispatch}
            draftFolderPrefix={draftFolderPrefix}
          />
        </FormikForm>
      )}
    </Formik>
  )
}

const HandleFormValidation = ({
  currentPageClickedNext,
  policyFormRef,
  values,
  pageNumber,
  dispatch,
  draftFolderPrefix,
}) => {
  React.useEffect(() => {
    if (values.isClaimantPolicyholder) {
      values.claimantName = values.policyHolderName
    }
    if (currentPageClickedNext) {
      policyFormRef.current.validateForm().then(errors => {
        // console.log(errors)
        if (Object.entries(errors).length === 0) {
          // console.log("PASS")
          batch(() => {
            dispatch(updateValidFormData("claimPADetail", values))
            // dispatch(pageIncrement())
            dispatch(updateClickedNext(pageNumber, false))
          })
          getPolicyInfoAPI(values, dispatch, draftFolderPrefix)
        } else {
          // console.log("FAIl")
          Alert.missingInfoAlert()
          policyFormRef.current.submitForm() // Set touched to all fields
          batch(() => {
            dispatch(updateClickedNext(pageNumber, false))
          })
        }
      })
    }
  }, [
    policyFormRef,
    values,
    pageNumber,
    dispatch,
    currentPageClickedNext,
    draftFolderPrefix,
  ])
  return null
}

const getPolicyInfoAPI = (values, dispatch, draftFolderPrefix) => {
  dispatch(controlLoading())

  //Call API to validate Personal Accident policy
  const validatePolicyPromise = API.apiPostRequest(
    "/Claim/PAValidatePolicyInfo",
    {
      PolicyNumber: values.policyNumber,
      PolicyHolderName: values.policyHolderName,
      NRIC: values.claimantNricNumber,
    },
    null
  )

  //Call API to get required documents for Basic coverage
  // const getRequiredDocumentPromise = API.apiPostRequest(
  //   "/Claim/GetRequiredDocumentList",
  //   {
  //     coverageId: Constants.basicCoverageDetailId,
  //   },
  //   null
  // )

  Promise.all([validatePolicyPromise])
    .then(values => {
      let validatePolicyResult = values[0].data

      if (
        validatePolicyResult.IsValidPolicy.toLowerCase() !== "y" &&
        validatePolicyResult.UpStatus.toLowerCase() === "true"
      ) {
        Alert.policyValidationAlert()
        dispatch(controlLoading())
      } else {
        validatePolicyResult.CoverageHeaderList.forEach(
          (headerItem, headerKey) => {
            headerItem.CoverageDetails.sort((a, b) =>
              a.CoverageDetailName > b.CoverageDetailName ? 1 : -1
            )
          }
        )

        const sortedCoverageHeaderList = []
          .concat(validatePolicyResult.CoverageHeaderList)
          .sort((a, b) =>
            a.HeaderDisplayOrder > b.HeaderDisplayOrder ? 1 : -1
          )

        const includeChildCoverageHeaderList = sortedCoverageHeaderList.filter(
          x => x.CoverageHeaderId === Constants.childCoverageHeaderId
        )

        batch(() => {
          dispatch(
            updateUiData("folderName", generateFolderName(draftFolderPrefix))
          )

          dispatch(updateUiData("coverageHeaderList", sortedCoverageHeaderList))

          dispatch(
            updateFromGetData("planPeriodFrom", validatePolicyResult.StartDate)
          )
          dispatch(
            updateFromGetData("planPeriodTo", validatePolicyResult.EndDate)
          )

          if (includeChildCoverageHeaderList.length > 0) {
            dispatch(updateUiData("isComeWithChildCoverage", true))
          }

          dispatch(
            updateValidFormData("claimAttributeModel", {
              ProductType: validatePolicyResult.ProductType,
            })
          )

          dispatch(pageIncrement())
          dispatch(controlLoading())
        })
      }
    })
    .catch(error => {
      navigate("errorOccurred")
    })
}

const generateFolderName = draftFolderPrefix => {
  let dd = new Date()
  let ss =
    "" +
    dd.getYear() +
    dd.getMonth() +
    dd.getDate() +
    dd.getHours() +
    dd.getMinutes() +
    dd.getSeconds()

  return draftFolderPrefix + ss
}
export default PolicyInformation
